import RadioInputGroup from '../../ui-components/RadioInputGroup'

const types = ['Default (topics with conversations, questions and answers)', 'Ideation (submit and upvote topics)']
const typeMap = {
  0: 'Default (topics with conversations, questions and answers)',
  2: 'Ideation (submit and upvote topics)'
}

const typeInverseMap = {
  'Default (topics with conversations, questions and answers)': 0,
  'Ideation (submit and upvote topics)': 2
}

const CategoryType = (props) => (
  <div className='form-group'>
    <RadioInputGroup
      title={'Type'}
      options={types}
      onChange={(e) => { props.onUpdate(typeInverseMap[e]) }}
      value={typeMap[props.currentType] || types[0]}
    />
  </div>
)

export default CategoryType
